<template>
  <v-card class="mx-auto">
    <v-app-bar dark color="primary">
      <v-icon large class="mr-3">notifications_paused</v-icon>
      <v-toolbar-title>Send Push Notification</v-toolbar-title>
    </v-app-bar>
    <v-card-text>
      <v-form ref="form">
        <v-row>
          <v-col>
            <v-autocomplete
              :items="countries"
              item-text="title"
              item-value="title"
              v-model="dataToSend.country"
              label="Country"
              required
              :rules="[(v) => !!v || 'Country is required']"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="dataToSend.title"
              label="Notification Title"
              outlined
              dense
              full-width
              required
              :rules="[(v) => (!!v && v.length > 0) || 'Title is required']"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="dataToSend.body"
              label="Notification Body"
              outlined
              dense
              full-width
              required
              :rules="[(v) => (!!v && v.length > 0) || 'Body Name is required']"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn color="primary" class="mt-3" @click="notifyRespondents">
              Send Notification
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import RestResource from "../../../services/dataServiceMobileV2";
import BuyerRestResource from "../../../services/dataServiceBuyer.js";

const service = new RestResource();
const buyerService = new BuyerRestResource();

export default {
  data() {
    return {
      countries: [],
      dataToSend: {
        country: undefined,
        title: "",
        body: "",
      },
    };
  },

  mounted() {
    this.fetchCountries();
  },

  methods: {
    fetchCountries() {
      buyerService.getConfig("countries").then((r) => {
        this.countries = r.data;
      });
    },
    notifyRespondents() {
      if (this.$refs.form.validate()) {
        this.$setLoader();
        if (this.dataToSend.country) {
          service.sendPushNotification(this.dataToSend).then((res) => {
            if (res) {
              this.dataToSend.title = "";
              this.dataToSend.body = "";
              this.$disableLoader();
            }
          });
        } else {
          console.error("Please select both Task and Status.");
        }
      }
    },

    validateTitle() {
      const title = this.dataToSend.title;
      return title ? true : "Title is required";
    },

    validateBody() {
      const body = this.dataToSend.body;
      return body ? true : "Body is required";
    },
  },
};
</script>
